import React, { useEffect, useState, useContext, useCallback } from "react";
import {
  useForm,
  FormProvider,
  useFormContext,
  useWatch,
} from "react-hook-form";
import moment from "moment";
//Function
import { getReportT1T2 } from "../api";
import { ApiDateTimeFormat, ToDateText } from "../../../utils/date";
//Material Ui
import Box from "@material-ui/core/Box";
import { Typography } from "@material-ui/core";
import LinearProgress from "@material-ui/core/LinearProgress";
//Component
import { BaseContainer } from "../../../stories/base-container";
import Criteria from "../criteria";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import ReportTable from "../table";
//Context
import {
  LoadingContext,
  withLoadingContext,
} from "../../../context/loading-context";
const columnsCDR = [
  { id: "CDR_TYPE", label: "CDR Type", minWidth: 170, dataAlign: "left" },
  { id: "RECORD_T1", label: "RECORD_T1", minWidth: 170, dataAlign: "right" },
  { id: "RECORD_T2", label: "RECORD_T2", minWidth: 170, dataAlign: "right" },
  {
    id: "RECORD_DIFF",
    label: "RECORD_DIFF",
    minWidth: 170,
    dataAlign: "right",
  },
  { id: "AMOUNT_T1", label: "AMOUNT_T1", minWidth: 170, dataAlign: "right" },
  { id: "AMOUNT_T2", label: "AMOUNT_T2", minWidth: 170, dataAlign: "right" },
  {
    id: "AMOUNT_DIFF",
    label: "AMOUNT_DIFF",
    minWidth: 170,
    dataAlign: "right",
  },
];
const columnsDom = [
  {
    id: "CDR_TYPE",
    label: "CDR Type",
    minWidth: 170,
    align: "center",
    dataAlign: "left",
  },
  { id: "T1", label: "T1", minWidth: 170, align: "center", dataAlign: "right" },
  { id: "T2", label: "T2", minWidth: 170, align: "center", dataAlign: "right" },
  {
    id: "DIF",
    label: "Different",
    minWidth: 170,
    align: "center",
    dataAlign: "right",
  },
];
const customheaderOFM = () => {
  return (
    <TableHead>
      <TableRow>
        <TableCell rowSpan={3} align="center">
          CDR Type
        </TableCell>
        <TableCell colSpan={6} align="center">
          DTN
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell colSpan={3} align="center">
          # of Records
        </TableCell>
        <TableCell colSpan={3} align="center">
          Amount
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell align="center">T1</TableCell>
        <TableCell align="center">T2</TableCell>
        <TableCell align="center">Different</TableCell>
        <TableCell align="center">T1</TableCell>
        <TableCell align="center">T2</TableCell>
        <TableCell align="center">Different</TableCell>
      </TableRow>
    </TableHead>
  );
};
function T1T2() {
  const methods = useForm({
    defaultValues: { date: moment().format(ApiDateTimeFormat) },
  });
  const Loading_context = useContext(LoadingContext);
  const { actions: load_actions } = Loading_context;
  const [CDR_lst, setCDR_lst] = useState([]);
  const [Dom_lst, setDom_lst] = useState([]);
  const [date, setDate] = useState();
  const { getValues } = methods;
  const query = useCallback(async () => {
    let param = getValues();
    let dat = await load_actions.withLoading(() => getReportT1T2(param));
    if (!dat) return;
    setCDR_lst(dat?.CDR?.Rows);
    setDom_lst(dat?.Domestic_Roaming?.Rows);
    setDate(ToDateText(dat?.Date));
  }, [load_actions, getValues]);
  useEffect(() => {
    query();
  }, [query]);

  return (
    <FormProvider {...methods}>
      <BaseContainer>
        {Loading_context.state?.isLoading ? (
          <div className="lineLoading">
            <LinearProgress />
          </div>
        ) : null}
        <Box display="flex" justifyContent="center">
          <Typography variant="h4">T1-T2 report</Typography>
        </Box>
        <Criteria query={query} />
        <Box display="flex" justifyContent="center">{`Date :${
          date || ""
        }`}</Box>
        <ReportTable
          data={CDR_lst}
          columns={columnsCDR}
          header={customheaderOFM}
          cellColor={[
            { fieldId: "RECORD_DIFF", fieldColor: "DIFF_RECORDS_COLOR_CODE" },
            { fieldId: "AMOUNT_DIFF", fieldColor: "DIFF_AMOUNT_COLOR_CODE" },
          ]}
        />
        <Box m={2}></Box>
        <ReportTable
          title="Domestic Roaming"
          data={Dom_lst}
          columns={columnsDom}
          cellColor={[{ fieldId: "DIF", fieldColor: "DIFF_COLOR_CODE" }]}
        />
      </BaseContainer>
    </FormProvider>
  );
}

export default withLoadingContext(T1T2);
